export default "__VITE_ASSET__BnGHTkMw__"